import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const Support = () => {
  return (
    <div>
      <Navbar />
      Support
      <Footer />
    </div>
  )
}

export default Support
